import { buildAddressLabel } from '../../shared/components/Forms/parse-google-address.util';
import { ZIP_CODE_PATTERN } from '../../shared/components/Forms/address-form.constants';
import { isValidEmail } from '../../shared/utils/is-valid-email.util';
import { DELIVERY_POINT_TYPE, DeliveryPointType } from '../types/delivery-point.type';

type StructuredAddress = { street: string; zipCode: string; city: string };

const MIN_TEXT_LENGTH = 2;
const MAX_TEXT_LENGTH = 100;
const CODE_MIN_LENGTH = 3;
const CODE_MAX_LENGTH = 20;

export const BOUNDED_TEXT_ERROR = `Entre ${MIN_TEXT_LENGTH} et ${MAX_TEXT_LENGTH} caractères`;

export const CODE_ERROR = `Entre ${CODE_MIN_LENGTH} et ${CODE_MAX_LENGTH} caractères`;

export const CODE_REQUIRED_ERROR = 'Un point entreprise doit avoir un code';

export const isZipCodeInvalid = (zipCode: string): boolean => zipCode.length > 0 && !ZIP_CODE_PATTERN.test(zipCode);

export const isBoundedTextInvalid = (value: string): boolean => {
  const trimmedLength = value.trim().length;
  return value.length > 0 && (trimmedLength < MIN_TEXT_LENGTH || trimmedLength > MAX_TEXT_LENGTH);
};

export const isEmailInvalid = (email: string): boolean => email.trim().length > 0 && !isValidEmail(email.trim());

export const isStructuredAddressComplete = ({ street, zipCode, city }: StructuredAddress): boolean =>
  Boolean(street.trim()) && ZIP_CODE_PATTERN.test(zipCode) && !isBoundedTextInvalid(city) && Boolean(city.trim());

export const toAddressLabel = ({ street, zipCode, city }: StructuredAddress): string =>
  buildAddressLabel({ street, zipCode, city, country: '' });

export const isCompanyType = (type: DeliveryPointType | ''): boolean => type === DELIVERY_POINT_TYPE.ENTREPRISE;

export const isCompanyCodeInvalid = (code: string): boolean => {
  const trimmedLength = code.trim().length;
  return trimmedLength < CODE_MIN_LENGTH || trimmedLength > CODE_MAX_LENGTH;
};

export const getCompanyCodeError = (code: string): string | undefined => {
  if (code.trim().length === 0) return CODE_REQUIRED_ERROR;
  return isCompanyCodeInvalid(code) ? CODE_ERROR : undefined;
};
